import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { colors } from 'shared/utils/chakra-theme/colors';

export const Loader = () => {
  return (
		<Flex
			justify="center"
			align="center"
			h="24px"
			w="24px"
		>
			<Box
				w="24px"
				h="24px"
				borderRadius="50%"
				border={`2px solid ${colors['primary-gray-40']}`}
				borderRightColor={colors['primary-gray-100']}
				display="inline-block"
				animation="0.75s linear 0s infinite normal both running spinner"
				bg="transparent !important"
			/>
		</Flex>
	);
};
